/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ef751f533bce45a13de245b7790ab8>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ProjectStatus".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing project status in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ProjectStatusIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.625A2.625 2.625 0 0 1 6.125 0h3.75A2.625 2.625 0 0 1 12.5 2.625v8.75A2.625 2.625 0 0 1 9.875 14H8.75v2h-1.5v-2H6.125A2.625 2.625 0 0 1 3.5 11.375zM6.125 1.5C5.504 1.5 5 2.004 5 2.625v8.75c0 .621.504 1.125 1.125 1.125h3.75c.621 0 1.125-.504 1.125-1.125v-8.75c0-.621-.504-1.125-1.125-1.125zM6.5 4.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ProjectStatusIcon.displayName = 'ProjectStatusIcon';
var _default = exports.default = ProjectStatusIcon;